export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-16 md:pt-24 border-t border-cream/10 overflow-hidden"
      style={{ background: "#000000" }}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pb-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-5">
          <div className="flex items-center gap-1">
            <span className="logo-mark w-10 h-10 md:w-11 md:h-11">
              <img src="/assets/logo-mark.png" alt="ऋ Design monogram" />
            </span>
            <span className="font-serif text-2xl md:text-3xl text-cream tracking-tight -ml-0.5">-design</span>
          </div>
          <p className="mt-6 max-w-md text-cream/60 text-sm md:text-base leading-relaxed font-light">
            A luxury design concierge &amp; creative consultancy for HNIs, founders
            and people looking for not so &lsquo;cheap thrills&rsquo;. Bespoke,
            discreet, and unmistakably yours.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-overline uppercase text-brass mb-4">Studio</div>
          <ul className="space-y-2 text-cream/85 font-serif text-lg">
            <li><a href="#services" className="link-underline">Services</a></li>
            <li><a href="#philosophy" className="link-underline">Philosophy</a></li>
            <li><a href="#vip" className="link-underline">VIP</a></li>
            <li><a href="#contact" className="link-underline">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-overline uppercase text-brass mb-4">Reach us</div>
          <ul className="space-y-2 text-cream/85 font-serif text-lg">
            <li><a href="tel:+919958721362" className="link-underline">+91 99587 21362</a></li>
            <li><a href="mailto:daftar@ridesign.in" className="link-underline">daftar@ridesign.in</a></li>
            <li className="text-cream/55 text-base">Mon–Sat 9am–9pm · Sun 12pm–10pm</li>
          </ul>
        </div>
      </div>

      {/* Giant logo mark */}
      <div className="relative pointer-events-none select-none">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex justify-center">
          <img
            src="/assets/logo-mark.png"
            alt=""
            aria-hidden
            className="opacity-90"
            style={{ width: "clamp(280px, 46vw, 640px)", marginBottom: "-8%" }}
          />
        </div>
      </div>

      <div className="relative border-t border-cream/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[10px] tracking-overline uppercase text-cream/40">
          <div>© {new Date().getFullYear()} ऋ Design · All rights reserved.</div>
          <div>Design Concierge · Creative Consultancy · Bespoke VIP</div>
        </div>
      </div>
    </footer>
  );
}
